import AllProductImageDownload from './AllProductImageDownload';
export default AllProductImageDownload;
